import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useEffect, useRef, useState } from 'react';
import type { HTMLTagProps, Size } from '@/types';
export type InputWrapProps = Omit<HTMLTagProps<'div'>, 'size'> & {
  size?: Size | 'fit-content';
  validationMessage?: string;
  message?: string;
  reversed?: boolean;
  label?: string;
  required?: boolean;
  shape?: 'rectangle' | 'capsule';
  isInvalid?: boolean;
};
export const InputWrap = t0 => {
  const $ = _c(50);
  let children;
  let className;
  let label;
  let message;
  let restDivProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let validationMessage;
  if ($[0] !== t0) {
    ({
      size: t1,
      validationMessage,
      message,
      reversed: t2,
      label,
      required: t3,
      isInvalid: t4,
      shape: t5,
      children,
      className,
      ...restDivProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = label;
    $[4] = message;
    $[5] = restDivProps;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = validationMessage;
  } else {
    children = $[1];
    className = $[2];
    label = $[3];
    message = $[4];
    restDivProps = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    validationMessage = $[11];
  }
  const size = t1 === undefined ? "large" : t1;
  const reversed = t2 === undefined ? false : t2;
  const required = t3 === undefined ? false : t3;
  const isInvalid = t4 === undefined ? false : t4;
  const shape = t5 === undefined ? "rectangle" : t5;
  const messageContainerRef = useRef(null);
  const [messageWrapHeight, setMessageWrapHeight] = useState();
  const hasMessage = !!(validationMessage || message);
  let t6;
  let t7;
  if ($[12] !== hasMessage) {
    t6 = () => {
      const {
        current
      } = messageContainerRef;
      if (current && hasMessage) {
        return setMessageWrapHeight({
          height: current.clientHeight
        });
      }
      return setMessageWrapHeight(undefined);
    };
    t7 = [hasMessage];
    $[12] = hasMessage;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== className) {
    t8 = cn("relative w-full", className);
    $[15] = className;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== label || $[18] !== required) {
    t9 = label ? <p className={cn("mb-8 text-[0.875rem] text-Gray-800", required && "after:text-[red] after:content-['_*']")}>{label}</p> : null;
    $[17] = label;
    $[18] = required;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = size === "small" && "h-32 text-[0.75rem]";
  const t11 = size === "medium" && "h-40 text-[0.875rem]";
  const t12 = size === "large" && "h-48 text-[1rem]";
  const t13 = size === "fit-content" && "h-fit p-0";
  const t14 = reversed && "flex-row-reverse";
  const t15 = shape === "rectangle" && "rounded-xsmall";
  const t16 = shape === "capsule" && "rounded-pill";
  const t17 = (validationMessage || isInvalid) && "border-[#fc3933] has-[:disabled]:border-transparent";
  let t18;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== t14 || $[25] !== t15 || $[26] !== t16 || $[27] !== t17) {
    t18 = cn("relative box-border flex w-full items-center justify-center gap-[0.8em] border border-Gray-400 px-16 text-Gray-900 transition-[color,background-color,border-color] duration-300", t10, t11, t12, t13, t14, t15, t16, "has-[:disabled]:border-Gray-300 has-[:disabled]:bg-Gray-300 has-[:disabled]:text-Gray-500", "not-has-[:disabled]:bg-Gray-white not-has-[:disabled]:has-[:focus]:border-[#8c919f]", t17);
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== children || $[30] !== t18) {
    t19 = <div className={t18}>{children}</div>;
    $[29] = children;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t19 || $[33] !== t9) {
    t20 = <label className="box-border flex w-full flex-col transition-[box-shadow,background-color] duration-300">{t9}{t19}</label>;
    $[32] = t19;
    $[33] = t9;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = messageWrapHeight && "pt-4";
  let t22;
  if ($[35] !== t21) {
    t22 = cn("h-0 pt-0 transition-[height,padding-top] duration-300", t21);
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== hasMessage || $[38] !== message || $[39] !== validationMessage) {
    t23 = hasMessage ? <div ref={messageContainerRef} className="mx-2 flex justify-between gap-[0.8em] text-[0.75rem] text-Gray-600"><span className="animate-shake animate-duration-[900ms]">{validationMessage}</span><span>{message}</span></div> : null;
    $[37] = hasMessage;
    $[38] = message;
    $[39] = validationMessage;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== messageWrapHeight || $[42] !== t22 || $[43] !== t23) {
    t24 = <div className={t22} style={messageWrapHeight}>{t23}</div>;
    $[41] = messageWrapHeight;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== restDivProps || $[46] !== t20 || $[47] !== t24 || $[48] !== t8) {
    t25 = <div {...restDivProps} className={t8}>{t20}{t24}</div>;
    $[45] = restDivProps;
    $[46] = t20;
    $[47] = t24;
    $[48] = t8;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  return t25;
};